var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "unit_reflection"
  }, [_c('div', {
    staticClass: "unit_select"
  }, [_c('Select', {
    staticStyle: {
      "width": "200px"
    },
    on: {
      "on-change": _vm.getTree
    },
    model: {
      value: _vm.upstream,
      callback: function ($$v) {
        _vm.upstream = $$v;
      },
      expression: "upstream"
    }
  }, [_c('Option', {
    attrs: {
      "value": "DING_TALK"
    }
  }, [_vm._v($t("q2w02", "钉钉"))]), _c('Option', {
    attrs: {
      "value": "WE_CHAT_WORK_PRIVATE"
    }
  }, [_vm._v($t("aamp644", "企业微信"))])], 1)], 1), _c('div', {
    staticClass: "content"
  }, [_vm.loading ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _c('AppDetailReflection', {
    attrs: {
      "treeData": _vm.treeData,
      "retVal": _vm.retVal,
      "leftTitle": _vm.isDingding ? $t("8yukcv6", "钉钉组织架构") : $t("mdi88t8", "企业微信组织架构")
    },
    on: {
      "on-delete-bind": _vm.onDeleteBind,
      "on-open-modal": _vm.onOpenBind
    }
  })], 1), _c('AppDetailPointModal', {
    ref: "AppDetailPointModal",
    on: {
      "on-submit-bind": _vm.onSubmitBind
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };